import React from 'react';

import { Tag as AntTag } from 'antd';

import type { EStatus } from 'helpers/enums';

type Props = {
  label: string;
  status: EStatus;
};

function Tag({ label, status }: Props) {
  return <AntTag color={status}>{label}</AntTag>;
}

export default Tag;
